import * as React from 'react'
import List from '@mui/material/List'
import { ResultItem } from '../../ResultItem/ResultItem'
import { SearchListItem } from '@user/store/search/typings'
import Stack from '@mui/material/Stack'
import { ScrollBox } from './ScrollBox.styled'
import { OnSearchAddressClick } from '../../ResultItem/typings'

type Props = {
  onLocationClick: () => void
  onRowClick: (searchItem: SearchListItem) => void
  searchList: SearchListItem[]
  searchText: string
  recent?: boolean
  onSearchAddressClick?: OnSearchAddressClick
}

export function SearchResultsList(props: Props) {
  const {
    onLocationClick,
    onRowClick,
    searchList,
    searchText,
    recent = false,
    onSearchAddressClick,
  } = props
  const [resultsHeight, setResultHeight] = React.useState('56vh')

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerHeight <= 350) {
        setResultHeight('30vh')
        return
      }
      setResultHeight('56vh')
    }
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Stack
      sx={{
        maxHeight: '60vh',
      }}
    >
      <ScrollBox style={{ maxHeight: resultsHeight }}>
        <List
          sx={{
            width: '100%',
            bgcolor: 'background.paper',
            paddingRight: 0,
            paddingTop: recent ? 0 : 0.8,
          }}
        >
          {searchList.map((searchItem, index) => (
            <ResultItem
              key={`search-item-${searchItem.entityId}-${index}`}
              onLocationClick={onLocationClick}
              onRowClick={onRowClick}
              primaryPropertyNames={['email']}
              searchItem={searchItem}
              searchText={searchText}
              recent={recent}
              onSearchAddressClick={onSearchAddressClick}
            />
          ))}
        </List>
      </ScrollBox>
    </Stack>
  )
}
